import React from 'react';
import Cliser from 'cliser';

export default class AuthView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let params = this.props.params;
    if (params.token) {
      window.localStorage.setItem("token", params.token)
      Cliser.LoginModel.setToken(params.token)
    }
    setTimeout(() => this.context.router.push('/'));
  }

  componentWillReceiveProps(props) {
    if (props.user) {
      setTimeout(() => this.context.router.push('/'));
    }
  }

  render() {
    return (
      <div>Authenticating...</div>
    )
  }
}

AuthView.propTypes = {
  error: React.PropTypes.string,
  params: React.PropTypes.object
}

AuthView.contextTypes = {
  router: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./client/views/AuthView.js